// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 0.671387L21 8.54639V20.0002H22V22.0002H13V20.0002H14V10.0002H10V20.0002H11V22.0002H2V20.0002H3V8.54639L12 0.671387ZM5.00079 20.0002H7.99921L8 10.0002H5L5.00079 20.0002ZM19 10.0002H16V20.0002H19L19 10.0002Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dam-filled')
export default class DamFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dam-filled',
    }
  }
}
